import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import MapboxLanguage from '@mapbox/mapbox-gl-language'
export var map;
mapboxgl.accessToken = 'pk.eyJ1Ijoic3BlZWR5ZXRhIiwiYSI6ImNsd3NsMDFubzBjdXkyanB6Y254ZDRiOXIifQ.T4ALSK1WM-yYxO_5hLFMDQ' //去mapbox管⽹申请
export function loadMap(box) {
	map = new mapboxgl.Map({
	container: box, //id
	style: 'mapbox://styles/mapbox/streets-v11', // mapbox官方的底图和样式文件
	// style:'mapbox://styles/lingling1108/cljhvd6t8000u01pjacro6f1w',//这里是我自己的样式。
	preserveDrawingBuffer: true,//允许地图导出为图片,
	// center: [-97.74571788753173,40.701712451168106], 
	center: [-97.74571788753173,40.701712451168106], 
	zoom: 9 
	});
	// mapboxgl.setRTLTextPlugin('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js');
	map.addControl(new MapboxLanguage({
	    defaultLanguage: 'en-US'
	}));
}

